/* eslint-disable import/prefer-default-export */
import { getECSDeployLevel } from '../../../utils';

export const getLocationServicesUrl = () => {
    // Local dev only: optionally point at a local location-tracking-service (sls offline),
    // e.g. http://localhost:3000/local/v1, for dev environments with port conflicts.
    // Unset keeps the deployed service for the current deploy level.
    if (window.location.hostname.includes('localhost') && process.env.REACT_APP_LOCAL_LOCATION_SERVICES_URL) {
        return process.env.REACT_APP_LOCAL_LOCATION_SERVICES_URL.replace(/\/+$/, '');
    }
    const deployLevel = getECSDeployLevel();
    return `https://location-services.${deployLevel}.milkmoovement.io/v1`;
};
